import { ca } from '@cian/analytics';

import { getAnalyticsProduct } from '@/packages/utils/analytics/getAnalyticsProducts';

import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';

export function trackOtherCardsShow(offers: IOfferForDesktopEnrichedV3Schema[]): void {
  ca('eventSite', {
    action: 'newpage_infinite_search',
    category: 'page',
    name: 'oldevent',
    label: '',
    products: offers.map(offer => getAnalyticsProduct({ offer })),
  });
}
